import { rei } from "@/services/api"

class CasamentoService {
  static storeCasamento (casamento) {
    // limpamos o telefone
    // (99) 99999-9999 => 99999999999
    casamento.pessoas[0].contato = CasamentoService.clearPhone(casamento.pessoas[0].contato)
    casamento.pessoas[1].contato = CasamentoService.clearPhone(casamento.pessoas[1].contato)

    return rei.post(`casamento`, casamento).then(res => res.data)
  }

  static getCasamento (id) {
    return rei.get(`casamento/${id}`).then(res => res.data)
  }

  static updateCasamento (casamento, id) {
    // limpamos o telefone
    // (99) 99999-9999 => 99999999999
    casamento.registro.pessoas[0].contato = CasamentoService.clearPhone(casamento.registro.pessoas[0].contato)
    casamento.registro.pessoas[1].contato = CasamentoService.clearPhone(casamento.registro.pessoas[1].contato)

    return rei.put(`casamento/${ id }`, casamento).then(res => res.data)
  }

  static clearPhone (contato) {
    return {
      ...contato,
      telefone_1: contato ? limparString(contato.telefone_1) : null,
      telefone_2: contato ? limparString(contato.telefone_2) : null,
      email: contato ? contato.email : null
    }
  }

  static transporte (params) {
    return rei.post(`transporte-casamento`, { ...params }).then(res => res.data)
  }
}

export default CasamentoService
